import { api } from './api';

export interface PaginaConteudo {
  html: string;
  css: string;
}

export interface PaginaEditor {
  id: string;
  slug: string;
  html: string;
  css: string;
  gjs_data: object;
  atualizado_por: string | null;
  atualizado_em: string;
  criado_em: string;
}

export const conteudoService = {
  async buscarPagina(slug: string): Promise<PaginaConteudo> {
    return api.get(`/conteudo/pagina/${slug}`);
  },

  async buscarEditor(slug: string): Promise<PaginaEditor> {
    return api.get(`/conteudo/editor/${slug}`);
  },

  async salvarPagina(
    slug: string,
    html: string,
    css: string,
    gjsData: object,
  ): Promise<PaginaEditor> {
    return api.put(`/conteudo/editor/${slug}`, { html, css, gjsData });
  },
};
